export enum DefaultCtaListItem {
  BookOnline = 'book_online',
  Phone = 'phone',
  RequestForm = 'request_form',
  VirtualCare = 'virtual_care'
}

export const CUSTOM_LIST_ITEM_TRACKING_ID = 'custom';
